import React from 'react'
import { MDXProvider } from "@mdx-js/react"
import Table from '@material-ui/core/Table';
// import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
// import TableContainer from '@material-ui/core/TableContainer';
// import TableHead from '@material-ui/core/TableHead';
// import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
const Tabla = ({children}) => <Table size="small" >{children}</Table>
export default function MdxCustomizer({ children }) {
  return (
    <MDXProvider
      components={{
        // Map HTML element tag to React component
        table: Tabla,
        tr: TableRow,
        td: TableCell,
        th: TableCell,
        // Or define component inline
        // p: props => <p {...props} style={{ color: "rebeccapurple" }} />,
      }}
    >
      {children}
    </MDXProvider>
  )
}